function generalValidator(data) {
  return !!(data.branch && data.number && data.bank)
}

export default generalValidator
